import styled from '@emotion/styled';
import {BrowserMessageType} from 'electron-communication-lib/BrowserForApp';
import {observer} from 'mobx-react-lite';
import React, {useState} from 'react';

import {useBrowserMessageExchange} from '_/hooks/useBrowserMessageExchange';
import {useVersionInfo} from '_/hooks/useVersionInfo';

const UVersionInformation = ({
  showDebugToggle,
}: {
  showDebugToggle: () => void;
}): React.ReactElement => {
  const unavailable = '(unavailable)';
  const [browserVersion, setBrowserVersion] = useState<{version: string}>();
  const [counter, setCounter] = useState(0);
  const version = useVersionInfo();

  const increaseCounter = () => {
    if (counter > 4) {
      showDebugToggle();
    }
    setCounter(counter + 1);
  };

  useBrowserMessageExchange({
    message: {type: BrowserMessageType.LEXIAN_BROWSER_VERSION, payload: null},
    responsePayloadHandler: setBrowserVersion,
  });

  return (
    <StyledUl>
      <li>
        Frontend:{' '}
        <HiddenButton tabIndex={-1} onClick={increaseCounter}>
          {version.frontend ?? unavailable}
        </HiddenButton>
      </li>
      <li>Backend: {version.backend ?? unavailable}</li>
      <li>Server URL: {document.location.host}</li>
      <li>Browser: {browserVersion?.version || navigator.userAgent}</li>
    </StyledUl>
  );
};

const HiddenButton = styled.button`
  border: none;
  background-color: var(--color-core-white);
  color: var(--color-core-black);
  display: inline;
  user-select: text;
  padding: 0;

  :hover {
    background-color: var(--color-core-white);
  }

  :focus {
    border: none;
    outline: none;
  }
`;

const StyledUl = styled.ul`
  margin: 0;
`;

export default observer(UVersionInformation);
